import { BeninFlag } from "@/components/landing/BeninFlag";

export const ZafaraLogoMark = ({ className = "h-9 w-9" }) => (
  <img
    src="/assets/zafara-cart-mark.png"
    alt="Zafara"
    className={`${className} object-contain select-none`}
    draggable="false"
    aria-hidden="true"
  />
);

export const ZafaraWordmark = ({ withCountry = true, className = "" }) => (
  <div className={`inline-flex flex-col items-start ${className}`}>
    <div className="flex items-baseline gap-0">
      <span className="font-display font-bold text-2xl leading-none text-[#0E7A3B]">Za</span>
      <span className="font-display font-bold text-2xl leading-none text-[#F5A800]">fara</span>
    </div>
    {withCountry && (
      <div className="mt-0.5 flex items-center gap-1.5">
        <span className="font-utility text-[10px] font-medium tracking-[0.2em] text-[#16241B]/70 uppercase">
          Bénin
        </span>
        <BeninFlag className="h-3 w-[18px]" />
      </div>
    )}
  </div>
);

export const ZafaraFullLogo = ({ className = "" }) => (
  <div className={`inline-flex items-center ${className}`}>
    <img
      src="/assets/zafara-logo.jpg"
      alt="Zafara Bénin"
      className="h-12 md:h-14 w-auto object-contain select-none"
      draggable="false"
    />
  </div>
);
